import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import AuthPage from './pages/AuthPage';
import PasswordResetPage from './pages/PasswordResetPage';
import CreatorDashboardWorking from './pages/CreatorDashboardWorking';
import AdminDashboard from './pages/AdminDashboard';
import PublicPortfolioPage from './pages/PublicPortfolioPage';
import PartnerWorkbench from './pages/PartnerWorkbench';
import BrokerOnboarding from './pages/BrokerOnboarding';
import CreatorOnboardingRebuilt from './pages/CreatorOnboardingRebuilt';
import BuyerOnboarding from './pages/BuyerOnboarding';
import AdminOnboarding from './pages/AdminOnboarding';
import PartnerOnboarding from './pages/PartnerOnboarding';
import ArchitectOnboarding from './pages/ArchitectOnboarding';
import BuyerDashboard from './pages/BuyerDashboard';
import BuyerNFTDetail from './pages/BuyerNFTDetail';
import BuyerMarketplacePage from './pages/BuyerMarketplacePage';
import BuyerDisputesPage from './pages/BuyerDisputesPage';
import BuyerHelpPage from './pages/BuyerHelpPage';
import BuyerSettingsPage from './pages/BuyerSettingsPage';
import BuyerHoldingsPage from './pages/BuyerHoldingsPage';
import BuyerPayoutsPage from './pages/BuyerPayoutsPage';
import BuyerPayoutDetail from './pages/BuyerPayoutDetail';
import BuyerUtilitiesPage from './pages/BuyerUtilitiesPage';
import BuyerTransfersPage from './pages/BuyerTransfersPage';
import BuyerTransferDetail from './pages/BuyerTransferDetail';
import InviteAcceptance from './pages/InviteAcceptance';
import BillingActivity from './pages/BillingActivity';
import PublicPortfolioPeek from './pages/PublicPortfolioPeek';
import PublicUnitPeek from './pages/PublicUnitPeek';
import MyPortfoliosPage from './pages/MyPortfoliosPage';
import CreatorPortfolioDetail from './pages/CreatorPortfolioDetail';
import ContractsPage from './pages/ContractsPage';
import ReadyToLaunchPage from './pages/ReadyToLaunchPage';
import PendingActionsPage from './pages/PendingActionsPage';
import CreatorPayoutsPageWorking from './pages/CreatorPayoutsPageWorking';
import CreatorPayoutDetail from './pages/CreatorPayoutDetail';
import CreatorUtilitiesPageWorking from './pages/CreatorUtilitiesPageWorking';
import CreatorBillingPageWorking from './pages/CreatorBillingPageWorking';
import CreatorDisputesPageWorking from './pages/CreatorDisputesPageWorking';
import CreatorSettingsPageWorking from './pages/CreatorSettingsPageWorking';
import BasicPortfolioWizard from './pages/BasicPortfolioWizard';
import EnhancedPortfolioWizard from './pages/EnhancedPortfolioWizard';
import LaunchReadinessPage from './pages/LaunchReadinessPage';
import KickbackEditPage from './pages/KickbackEditPage';
import KickbackReviewPage from './pages/KickbackReviewPage';
import CreatorUtilitiesMarketplace from './pages/CreatorUtilitiesMarketplace';
import UtilityVaultPage from './pages/UtilityVaultPage';
import CreatorAnalyticsPage from './pages/CreatorAnalyticsPage';
import EnterpriseInquiryPage from './pages/EnterpriseInquiryPage';
import AdminEnterpriseInquiriesPage from './pages/AdminEnterpriseInquiriesPage';
import AdminLaunchBridgePage from './pages/AdminLaunchBridgePage';
import CreatorPublishUtility from './pages/CreatorPublishUtility';
import CreatorMyListings from './pages/CreatorMyListings';
import CreatorModeSelector from './pages/CreatorModeSelector';
import ContractTemplatesPage from './pages/ContractTemplatesPage';
import ContractDraftForm from './pages/ContractDraftForm';
import CreatorContractsUsedPage from './pages/CreatorContractsUsedPage';
import CreatorContractsNewCTA from './pages/CreatorContractsNewCTA';
// Phase F1 — Creator Compliance Center + Portfolio Rules Editor
import CreatorComplianceCenter from './pages/CreatorComplianceCenter';
import PortfolioRulesEditor from './pages/PortfolioRulesEditor';
// Phase F2 — Buyer Dashboard Completion
import BuyerNFTLibrary from './pages/BuyerNFTLibrary';
import BuyerPortfolioView from './pages/BuyerPortfolioView';
import BuyerDistributionCenter from './pages/BuyerDistributionCenter';
import BuyerTaxCenter from './pages/BuyerTaxCenter';
import BuyerNotificationsCenter from './pages/BuyerNotificationsCenter';
import BuyerAnnouncements from './pages/BuyerAnnouncements';
// RAP Gift Engine
import BuyerGiftsPage from './pages/BuyerGiftsPage';
// Phase 3 — Claim Links / Holder Redeem
import PublicClaimPage from './pages/PublicClaimPage';
import BuyerClaimsPage from './pages/BuyerClaimsPage';
import BuyerClaimDetailPage from './pages/BuyerClaimDetailPage';
import BuyerBenefitDetailPage from './pages/BuyerBenefitDetailPage';
// Phase 4 — Utility Approval Workflow
import ProviderUtilitiesApproval from './pages/ProviderUtilitiesApproval';
import AdminUtilitiesQueue from './pages/AdminUtilitiesQueue';
// Phase 5 — Kickback Architect System
import ArchitectProfilePage from './pages/ArchitectProfilePage';
import ArchitectRequestsPage from './pages/ArchitectRequestsPage';
import CreatorArchitectRequestsPage from './pages/CreatorArchitectRequestsPage';
import AdminArchitectsReviewPage from './pages/AdminArchitectsReviewPage';
import AdminArchitectRequestsPage from './pages/AdminArchitectRequestsPage';
// Phase 6 — AI Assistant admin settings
import AdminAISettingsPage from './pages/AdminAISettingsPage';
// Phase 2 — PMPro bridge post-payment landing
import PostPaymentPage from './pages/PostPaymentPage';
import SupportPage from './pages/SupportPage';
// Phase F3 — Provider Dashboard Completion
import ProviderComplianceCenter from './pages/ProviderComplianceCenter';
import ProviderProfileEditor from './pages/ProviderProfileEditor';
import ProviderAssignmentInbox from './pages/ProviderAssignmentInbox';
import ProviderDashboardF3 from './pages/ProviderDashboardF3';
import ProviderDistributionCenter from './pages/ProviderDistributionCenter';
import ProviderTaxCenter from './pages/ProviderTaxCenter';
import ProviderNotificationsCenter from './pages/ProviderNotificationsCenter';
// Phase F4 — Admin Dashboard Completion
import AdminComplianceReviewCenter from './pages/AdminComplianceReviewCenter';
import AdminProviderOversight from './pages/AdminProviderOversight';
import AdminDistributionApprovalQueue from './pages/AdminDistributionApprovalQueue';
import AdminSupportCenter from './pages/AdminSupportCenter';
import AdminFraudCenter from './pages/AdminFraudCenter';
import AdminAuditLogCenter from './pages/AdminAuditLogCenter';
import AdminNotificationsCenter from './pages/AdminNotificationsCenter';
import GuidedTour from './components/GuidedTour';
const CreatorTourMount = ({ user }) => <GuidedTour user={user} />;
import ContractDraftDetail from './pages/ContractDraftDetail';
import ContractDeployPage from './pages/ContractDeployPage';
import NftProjectsList from './pages/NftProjectsList';
import NftProjectCreate from './pages/NftProjectCreate';
import NftProjectDetail from './pages/NftProjectDetail';
import NftArtStudio from './pages/NftArtStudio';
import NftArtAI from './pages/NftArtAI';
import NftArtTraits from './pages/NftArtTraits';
import NftProjectArt from './pages/NftProjectArt';
import BrokerPortfoliosPage from './pages/BrokerPortfoliosPage';
import BrokerDirectoryPage from './pages/BrokerDirectoryPage';
import BrokerPayoutsPage from './pages/BrokerPayoutsPage';
import BrokerDisputesPage from './pages/BrokerDisputesPage';
import BrokerSettingsPage from './pages/BrokerSettingsPage';
import HelpPage from './pages/HelpPage';
import SearchResultsPage from './pages/SearchResultsPage';
import NotificationsPage from './pages/NotificationsPage';
import CreatorUtilityDetailPage from './pages/CreatorUtilityDetailPage';
import CreatorListingDetailPage from './pages/CreatorListingDetailPage';
import CreatorDisputeDetailPage from './pages/CreatorDisputeDetailPage';
import AppLayout from './components/AppLayout';
import GlobalHeader from './components/GlobalHeader';
import CreatorSidebar from './components/CreatorSidebar';
import { Toaster } from './components/ui/sonner';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Axios interceptor for auth token
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);  // P2.1.1: Single auth loading state

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    setAuthLoading(true);
    const token = localStorage.getItem('token');
    if (!token) {
      setAuthLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem('token');
    }
    setAuthLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  // P2.1.1: Loading component to prevent redirect flicker
  const AuthLoadingSpinner = () => (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#FFFFFF' }}>
      <div className="text-xl" style={{ color: '#14151A' }}>Loading...</div>
    </div>
  );

  // P2.1.1: Onboarding guard with auth loading check
  const RequireOnboarding = ({ children, role }) => {
    // P2.1.1: If auth is still loading, show loading state (NO redirects)
    if (authLoading) {
      return <AuthLoadingSpinner />;
    }
    
    // If no user after loading complete, redirect to auth
    if (!user) return <Navigate to="/auth" />;
    
    // P2.1: Check role match (broker users access broker/* routes)
    if (user.role !== role) {
      const dashboardMap = { creator: '/creator/dashboard', broker: '/broker/dashboard', buyer: '/buyer/dashboard', admin: '/admin/dashboard' };
      return <Navigate to={dashboardMap[user.role] || '/dashboard'} />;
    }
    
    // P2.1: If onboarding not complete, redirect to onboarding
    if (!user.onboarding_complete) {
      const roleMap = { creator: 'creator', broker: 'partner', buyer: 'buyer', admin: 'admin' };
      return <Navigate to={`/onboarding/${roleMap[role] || role}`} />;
    }
    
    return children;
  };

  // P2.1.1: Top-level loading guard
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#FFFFFF' }}>
        <div className="text-xl" style={{ color: '#14151A' }}>Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          {/* Auth Route */}
          <Route path="/auth" element={!user ? <AuthPage setUser={setUser} /> : <Navigate to="/dashboard" />} />
          <Route path="/auth/reset" element={<PasswordResetPage />} />
          
          {/* Onboarding Routes */}
          <Route path="/onboarding/creator" element={user && user.role === 'creator' ? <CreatorOnboardingRebuilt user={user} setUser={setUser} /> : <Navigate to="/auth" />} />
          <Route path="/creator/select-mode" element={user && user.role === 'creator' ? <CreatorModeSelector user={user} /> : <Navigate to="/auth" />} />
          <Route path="/onboarding/partner" element={user && user.role === 'broker' ? <PartnerOnboarding setUser={setUser} /> : <Navigate to="/auth" />} />
          <Route path="/onboarding/buyer" element={user && user.role === 'buyer' ? <BuyerOnboarding setUser={setUser} /> : <Navigate to="/auth" />} />
          <Route path="/onboarding/admin" element={user && user.role === 'admin' ? <AdminOnboarding setUser={setUser} /> : <Navigate to="/auth" />} />
          <Route path="/onboarding/architect" element={<ArchitectOnboarding user={user} setUser={setUser} />} />
          
          {/* Creator Routes (with onboarding guard) */}
          <Route path="/creator/*" element={
            <RequireOnboarding role="creator">
              <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <GlobalHeader user={user} onLogout={handleLogout} />
                <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                  <CreatorSidebar user={user} />
                  <main style={{ flex: 1, overflowY: 'auto' }}>
                    <Routes>
                      <Route path="dashboard" element={<CreatorDashboardWorking user={user} />} />
                      <Route path="compliance" element={<CreatorComplianceCenter user={user} />} />
                      <Route path="portfolios/:portfolioId/rules" element={<PortfolioRulesEditor user={user} />} />
                      <Route path="portfolios" element={<MyPortfoliosPage user={user} />} />
                      <Route path="portfolios/:id" element={<CreatorPortfolioDetail user={user} />} />
                      <Route path="portfolios/:id/launch-readiness" element={<LaunchReadinessPage user={user} />} />
                      <Route path="portfolios/:id/edit" element={<KickbackEditPage user={user} />} />
                      <Route path="portfolios/:id/review" element={<KickbackReviewPage user={user} />} />
                      <Route path="contracts" element={<ContractsPage user={user} />} />
                      <Route path="contracts/used" element={<CreatorContractsUsedPage user={user} />} />
                      <Route path="contracts/new" element={<CreatorContractsNewCTA />} />
                      <Route path="contracts/templates" element={<ContractTemplatesPage user={user} />} />
                      <Route path="contracts/drafts/new" element={<ContractDraftForm user={user} />} />
                      <Route path="contracts/drafts/:id" element={<ContractDraftDetail user={user} />} />
                      <Route path="contracts/:id/deploy" element={<ContractDeployPage user={user} />} />
                      <Route path="contracts/:id" element={<ContractDraftDetail user={user} />} />
                      <Route path="nft/projects" element={<NftProjectsList user={user} />} />
                      <Route path="nft/projects/new" element={<NftProjectCreate user={user} />} />
                      <Route path="nft/projects/:id" element={<NftProjectDetail user={user} />} />
                      <Route path="nft-art" element={<NftArtStudio user={user} />} />
                      <Route path="nft-art/ai" element={<NftArtAI user={user} />} />
                      <Route path="nft-art/traits" element={<NftArtTraits user={user} />} />
                      <Route path="nft-projects/:id/art" element={<NftProjectArt user={user} />} />
                      <Route path="ready-to-launch" element={<ReadyToLaunchPage user={user} />} />
                      <Route path="pending-actions" element={<PendingActionsPage user={user} />} />
                      <Route path="portfolios/new" element={
                        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: '#FFFFFF', zIndex: 1000, overflowY: 'auto' }}>
                          <EnhancedPortfolioWizard user={user} />
                        </div>
                      } />
                      <Route path="payouts" element={<CreatorPayoutsPageWorking user={user} />} />
                      <Route path="payouts/:payoutId" element={<CreatorPayoutDetail user={user} />} />
                      <Route path="billing" element={<CreatorBillingPageWorking user={user} />} />
                      <Route path="utilities" element={<CreatorUtilitiesPageWorking user={user} />} />
                      <Route path="utilities/:utilityId" element={<CreatorUtilityDetailPage user={user} />} />
                      <Route path="utilities-marketplace" element={<CreatorUtilitiesMarketplace user={user} />} />
                      <Route path="utility-vault" element={<UtilityVaultPage user={user} />} />
                      <Route path="analytics" element={<CreatorAnalyticsPage user={user} />} />
                      <Route path="publish-utility" element={<CreatorPublishUtility user={user} />} />
                      <Route path="my-listings" element={<CreatorMyListings user={user} />} />
                      <Route path="listings/:listingId" element={<CreatorListingDetailPage user={user} />} />
                      <Route path="disputes" element={<CreatorDisputesPageWorking user={user} />} />
                      <Route path="disputes/:disputeId" element={<CreatorDisputeDetailPage user={user} />} />
                      <Route path="settings" element={<CreatorSettingsPageWorking user={user} />} />
                      <Route path="architect-requests" element={<CreatorArchitectRequestsPage user={user} />} />
                      <Route path="notifications" element={<NotificationsPage user={user} />} />
                      <Route path="search" element={<SearchResultsPage user={user} />} />
                      <Route path="*" element={<Navigate to="/creator/dashboard" />} />
                    </Routes>
                  </main>
                </div>
                <CreatorTourMount user={user} />
              </div>
            </RequireOnboarding>
          } />
          
          {/* Help Route (accessible to all roles) */}
          <Route path="/help" element={user ? <HelpPage user={user} /> : <Navigate to="/auth" />} />
          
          {/* Portfolio Partner Routes (with onboarding guard) */}
          <Route path="/broker/*" element={
            <RequireOnboarding role="broker">
              <AppLayout user={user} onLogout={handleLogout}>
                <Routes>
                  <Route path="dashboard" element={<PartnerWorkbench user={user} />} />
                  <Route path="portfolios" element={<BrokerPortfoliosPage user={user} />} />
                  <Route path="directory" element={<BrokerDirectoryPage user={user} />} />
                  <Route path="payouts" element={<BrokerPayoutsPage user={user} />} />
                  <Route path="disputes" element={<BrokerDisputesPage user={user} />} />
                  <Route path="settings" element={<BrokerSettingsPage user={user} />} />
                  <Route path="utility-approval" element={<ProviderUtilitiesApproval user={user} />} />
                  {/* Phase F3 — Provider Dashboard Completion */}
                  <Route path="overview" element={<ProviderDashboardF3 user={user} />} />
                  <Route path="compliance" element={<ProviderComplianceCenter user={user} />} />
                  <Route path="profile" element={<ProviderProfileEditor user={user} />} />
                  <Route path="inbox" element={<ProviderAssignmentInbox user={user} />} />
                  <Route path="distributions" element={<ProviderDistributionCenter user={user} />} />
                  <Route path="tax" element={<ProviderTaxCenter user={user} />} />
                  <Route path="notifications" element={<ProviderNotificationsCenter user={user} />} />
                  <Route path="search" element={<SearchResultsPage user={user} />} />
                  <Route path="*" element={<Navigate to="/broker/dashboard" />} />
                </Routes>
              </AppLayout>
            </RequireOnboarding>
          } />
          
          {/* Buyer Routes (with onboarding guard) */}
          <Route path="/buyer/*" element={
            <RequireOnboarding role="buyer">
              <AppLayout user={user} onLogout={handleLogout}>
                <Routes>
                  <Route path="dashboard" element={<BuyerDashboard user={user} />} />
                  <Route path="holdings" element={<BuyerHoldingsPage />} />
                  <Route path="payouts" element={<BuyerPayoutsPage />} />
                  <Route path="payouts/:id" element={<BuyerPayoutDetail />} />
                  <Route path="utilities" element={<BuyerUtilitiesPage />} />
                  <Route path="marketplace" element={<BuyerMarketplacePage />} />
                  <Route path="disputes" element={<BuyerDisputesPage />} />
                  <Route path="settings" element={<BuyerSettingsPage user={user} />} />
                  <Route path="help" element={<BuyerHelpPage />} />
                  <Route path="nfts/:id" element={<BuyerNFTDetail />} />
                  <Route path="transfers" element={<BuyerTransfersPage />} />
                  <Route path="transfers/:id" element={<BuyerTransferDetail />} />
                  {/* Phase F2 — Buyer Dashboard Completion */}
                  <Route path="library" element={<BuyerNFTLibrary />} />
                  <Route path="portfolios/:portfolioId" element={<BuyerPortfolioView />} />
                  <Route path="distributions" element={<BuyerDistributionCenter />} />
                  <Route path="tax" element={<BuyerTaxCenter />} />
                  <Route path="notifications" element={<BuyerNotificationsCenter />} />
                  <Route path="announcements" element={<BuyerAnnouncements />} />
                  <Route path="gifts" element={<BuyerGiftsPage />} />
                  <Route path="claims" element={<BuyerClaimsPage />} />
                  <Route path="claims/:redemptionId" element={<BuyerClaimDetailPage />} />
                  <Route path="benefits/:portfolioId/:associationKey" element={<BuyerBenefitDetailPage />} />
                  <Route path="search" element={<SearchResultsPage user={user} />} />
                  <Route path="*" element={<Navigate to="/buyer/dashboard" />} />
                </Routes>
              </AppLayout>
            </RequireOnboarding>
          } />
          
          {/* Architect Routes (Phase 5) */}
          <Route path="/architect/*" element={
            user && user.role === 'architect' ? (
              <AppLayout user={user} onLogout={handleLogout}>
                <Routes>
                  <Route path="profile" element={<ArchitectProfilePage user={user} />} />
                  <Route path="requests" element={<ArchitectRequestsPage user={user} />} />
                  <Route path="*" element={<Navigate to="/architect/profile" />} />
                </Routes>
              </AppLayout>
            ) : <Navigate to="/auth" />
          } />

          {/* Admin Routes (with onboarding guard) */}
          <Route path="/admin/*" element={
            <RequireOnboarding role="admin">
              <AppLayout user={user} onLogout={handleLogout}>
                <Routes>
                  <Route path="dashboard" element={<AdminDashboard user={user} />} />
                  {/* Phase F4 — Admin Dashboard Completion */}
                  <Route path="compliance" element={<AdminComplianceReviewCenter user={user} />} />
                  <Route path="providers" element={<AdminProviderOversight user={user} />} />
                  <Route path="distributions" element={<AdminDistributionApprovalQueue user={user} />} />
                  <Route path="support" element={<AdminSupportCenter user={user} />} />
                  <Route path="fraud" element={<AdminFraudCenter user={user} />} />
                  <Route path="utilities" element={<AdminUtilitiesQueue user={user} />} />
                  <Route path="architects" element={<AdminArchitectsReviewPage user={user} />} />
                  <Route path="architect-requests" element={<AdminArchitectRequestsPage user={user} />} />
                  <Route path="ai-settings" element={<AdminAISettingsPage user={user} />} />
                  <Route path="audit" element={<AdminAuditLogCenter user={user} />} />
                  <Route path="notifications" element={<AdminNotificationsCenter user={user} />} />
                  <Route path="enterprise-inquiries" element={<AdminEnterpriseInquiriesPage user={user} />} />
                  <Route path="launch-bridge" element={<AdminLaunchBridgePage user={user} />} />
                  <Route path="search" element={<SearchResultsPage user={user} />} />
                  <Route path="*" element={<Navigate to="/admin/dashboard" />} />
                </Routes>
              </AppLayout>
            </RequireOnboarding>
          } />
          
          {/* Legacy dashboard redirect */}
          <Route path="/dashboard" element={
            user ? (
              user.role === 'creator' ? <Navigate to="/creator/dashboard" /> :
              user.role === 'broker' ? <Navigate to="/broker/dashboard" /> :
              user.role === 'buyer' ? <Navigate to="/buyer/dashboard" /> :
              user.role === 'admin' ? <Navigate to="/admin/dashboard" /> :
              user.role === 'architect' ? <Navigate to="/architect/profile" /> :
              <Navigate to="/auth" />
            ) : <Navigate to="/auth" />
          } />
          
          {/* Public Routes - P1.1: Unified invite acceptance */}
          <Route path="/invite/accept/:token" element={<InviteAcceptance />} />
          <Route path="/public/invite/:token" element={<InviteAcceptance />} />
          <Route path="/public/portfolio/:portfolioId" element={<PublicPortfolioPeek />} />
          <Route path="/post-payment/:token" element={<PostPaymentPage setUser={setUser} />} />
          <Route path="/support" element={<SupportPage user={user} setUser={setUser} /> } />
          <Route path="/claim/:token" element={<PublicClaimPage />} />
          <Route path="/enterprise-inquiry" element={<EnterpriseInquiryPage />} />
          <Route path="/public/unit/:unitId" element={<PublicUnitPeek />} />
          <Route path="/portfolio/:portfolioId" element={<PublicPortfolioPage />} />
          <Route path="/" element={<Navigate to={user ? '/dashboard' : '/auth'} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;